import ModalHeader from './ModalHeader'

export default ModalHeader
